import { useMemo, type FC } from "react";

import { todosFromToolOutput } from "../../plan/model";
import { TodoQueue } from "../../plan/TodoQueue";
import { useHasBuildCard } from "../runEvents";

import type { AnyToolPart } from "./ToolCard";

type Props = {
  part: AnyToolPart;
};

/**
 * An `update_todos` result as a checklist so progress is visible in chat.
 * While a plan is being built from its Build card, that card is the
 * progress (Cursor's), so the result renders nothing here.
 */
export const TodoListCard: FC<Props> = ({ part }) => {
  const result = useMemo(
    () =>
      part.state === "output-available"
        ? todosFromToolOutput(part.output)
        : null,
    [part]
  );
  const ownedByBuildCard = useHasBuildCard(result?.planId ?? null);
  if (!result?.todos.length || ownedByBuildCard) return null;
  return (
    <TodoQueue todos={result.todos} label={result.title ?? "Todos"} unbounded />
  );
};
